import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as actions from '@store/actions';

import MobileNav from '@components/Quoting/MobileNav/MobileNav';
import TextBox from '@components/TextBox/TextBox';
import LegInfo from './LegInfo/LegInfo';
import ProgressBox from '@components/ProgressBox/ProgressBox';
import PriceTooltip from '@components/Quoting/Board/Pricing/PricingRow/PriceTooltip/PriceTooltip';
import ImportImages from '@src/importImages';

/*const P100 = ImportImages('/quoting/p100.png');
const P300 = ImportImages('/quoting/p300.png');*/
const P100 = ImportImages('/compare/p100.png');
const P300 = ImportImages('/compare/p300.png');

class TripSummary extends Component {
  state = {
    tooltipOpen: ''
  };

  toggleTooltip = tooltip => {
    this.setState({
      tooltipOpen: tooltip === this.state.tooltipOpen ? '' : tooltip
    });
  };

  onSubmit = () => {
    const { user, flightInfo, aircraft, passengers } = this.props;
    const legs = flightInfo[aircraft].legs.map((leg, index) => {
      return {
        details: leg,
        passengers: passengers[index],
        leg_info: this.props.legInfo[index]
      };
    });

    const { aircraftLabel } = this.getAircraftLabel(aircraft);
    const postData = {
      member: {
        firstName: user.data.FirstName,
        lastName: user.data.LastName,
        phone: user.data.HomePhone,
        email: user.mail
      },
      aircraft: aircraftLabel,
      contractVersion: this.props.contractVersion,
      bookerInfo: {
        accountName: this.props.accountName,
        contactEmail: this.props.contactEmail
      },
      legs
    };
    this.props.onSubmit(postData);
  };

  componentDidMount = () => {
    window.addEventListener('quote-submitted', this.props.nextClick);
  };

  componentWillUnmount = () => {
    window.removeEventListener('quote-submitted', this.props.nextClick);
  };

  getAircraftLabel = aircraft => {
    let aircraftLabel = '';
    let tooltipText = '';
    let aircraftImage = P100;
    switch (aircraft) {
      case '525B':
        aircraftLabel = 'JetSuite Phenom 300';
        tooltipText =
          'JetSuite Phenom 300s are priced primarily to fly East of the Mississippi.';
        aircraftImage = P300;
        break;
      case 'E50P':
        aircraftLabel = 'JetSuite Phenom 100';
        tooltipText =
          'JetSuite Phenom 100s are priced primarily to fly in the West and Texas.';
        break;
      default:
        aircraftLabel = 'JetSuite Phenom 100';
        tooltipText =
          'JetSuite Phenom 100s are priced primarily to fly in the West and Texas.';
    }

    return { aircraftLabel, aircraftImage, tooltipText };
  };

  render = () => {
    const { isMobile, flightInfo, aircraft, passengers } = this.props;

    let i = 0;
    const summaryRows = [];
    const { aircraftLabel, aircraftImage, tooltipText } = this.getAircraftLabel(
      aircraft
    );

    let totalTripPrice = 0;

    while (i < flightInfo.legs_amount) {
      let legData = flightInfo[aircraft].legs[i];
      totalTripPrice += legData.total;
      summaryRows.push(
        <LegInfo
          key={i}
          index={i + 1}
          aircraft={aircraftLabel}
          aircraftKey={aircraft}
          {...legData}
          legInfo={this.props.legInfo[i]}
          passengers={passengers[i]}
          tooltipOpen={this.state.tooltipOpen}
          toggleTooltip={this.toggleTooltip}
          isMobile={isMobile}
          contractVersion={this.props.data.profile_ContractVersion}
        />
      );
      i++;
    }

    return (
      <React.Fragment>
        {isMobile && <MobileNav {...this.props} title={'Trip Summary'} />}
        <TextBox header={isMobile ? false : 'Trip Summary'}>
          {this.props.loading && (
            <ProgressBox
              text={'Submitting ...'}
              icon={<FontAwesomeIcon icon={['far', 'spinner']} spin />}
            />
          )}
          {/* TOP SUMMARY BOX */}
          <div className={'position-relative mb-3'}>
            <div
              className={
                'color-red text-uppercase lakes-medium font-sm text-left'
              }
            >
              Summary
            </div>
            <div
              className={'border-grey background-white p-3 font-sm text-left'}
            >
              <Row>
                <Col>
                  <img
                    src={aircraftImage}
                    alt={'Aircraft'}
                    style={{ height: '30px' }}
                    className={'mr-3 image-circle'}
                  />
                  {aircraftLabel}
                  <PriceTooltip
                    tooltipOpen={this.state.tooltipOpen}
                    index={`summary-total`}
                    toggleTooltip={this.toggleTooltip}
                    fees={[]}
                    items={[tooltipText]}
                    title={false}
                  />
                </Col>
                {this.props.data.profile_ContractVersion !== 2 && (
                  <Col className={'text-right font-sm'}>
                    <div className={'color-red'}>
                      Total Trip Price:{' '}
                      <span className={'asap-bold'}>
                        <CurrencyFormat
                          value={totalTripPrice}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                      </span>
                    </div>
                    <div className={'text-right font-xs'}>
                      *Price Includes 7.5% Federal Excise Tax (FET).
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </div>

          {/* WHOS BUYING */}
          <div className={'position-relative mb-3'}>
            <div
              className={
                'color-red text-uppercase lakes-medium font-sm text-left'
              }
            >
              {this.props.data.profile_ContractVersion !== 2 ? (
                <span>Who's Buying</span>
              ) : (
                <span>Who's Booking</span>
              )}
            </div>
            <div
              className={'border-grey background-white p-3 font-sm text-left'}
            >
              {this.props.contractVersion === 2 ? (
                <Row>
                  <Col
                    xs={12}
                    sm={6}
                    className={isMobile ? 'text-center asap-bold' : 'asap-bold'}
                  >
                    {this.props.accountName}
                  </Col>
                  <Col xs={12} sm={6} className={isMobile ? 'text-center' : ''}>
                    {this.props.contactEmail}
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col
                    xs={12}
                    sm={4}
                    className={isMobile ? 'text-center asap-bold' : 'asap-bold'}
                  >
                    {this.props.user.data.FirstName}{' '}
                    {this.props.user.data.LastName}
                  </Col>
                  <Col xs={12} sm={4} className={'text-center'}>
                    {this.props.user.mail}
                  </Col>
                  <Col
                    xs={12}
                    sm={4}
                    className={isMobile ? 'text-center' : 'text-right'}
                  >
                    {this.props.user.data.HomePhone}
                  </Col>
                </Row>
              )}
            </div>
          </div>
          {summaryRows}
        </TextBox>

        {!isMobile && (
          <button
            className="btn btn-transparent mt-2 float-left"
            onClick={this.props.prevClick}
          >
            <strong>
              <FontAwesomeIcon icon={['fas', 'chevron-left']} />
              &nbsp;&nbsp;Back
            </strong>
          </button>
        )}
        <button
          className={
            'btn btn-fullred ' +
            (isMobile ? 'mx-auto d-block mt-0 mb-5' : 'float-right mt-2')
          }
          onClick={this.onSubmit}
        >
          REQUEST TRIP
          {}
        </button>
        <div className={'clearfix'} style={{ clear: 'both' }} />
      </React.Fragment>
    );
  };
}

const mapStateToProps = state => {
  return {
    user: state.auth,
    flightInfo: state.flightInfo.data,
    legInfo: state.flightInfo.legInfo,
    aircraft: state.flightInfo.aircraft,
    loading: state.flightInfo.loading,
    passengers: state.flightInfo.passengers,
    contractVersion: state.auth.data.profile_ContractVersion,
    accountName: state.flightInfo.accountName,
    contactEmail: state.flightInfo.contactEmail
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: postData => dispatch(actions.quotingSubmit(postData))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripSummary);



// WEBPACK FOOTER //
// ./src/components/Quoting/Board/TripSummary/TripSummary.jsx